import React from 'react';
import cn from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import InputLabel from '@wix/da-ds/pkg/formControls/lego/InputLabel';
import InputLabelText from '@wix/da-ds/pkg/formControls/lego/InputLabelText';
import InputLabelSubText from '@wix/da-ds/pkg/formControls/lego/InputLabelSubText';

import s from './ButtonFieldLayout.scss';

interface Props {
  className?: string;
  label: React.ReactNode;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  subLabel?: React.ReactNode;
  bottomSlot?: React.ReactNode;
}

const ButtonFieldLayout = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<Props>
>(({ className, label, labelProps, subLabel, bottomSlot, children }, ref) => {
  return (
    <div className={cn(s['root'], className)} ref={ref}>
      <Flex direction="row" alignItems="center" justifyContent="space-between">
        <InputLabel className={s['label']} {...labelProps}>
          <InputLabelText className={s['label-text']}>{label}</InputLabelText>
          {subLabel && (
            <InputLabelSubText className={s['sublabel-text']}>
              {subLabel}
            </InputLabelSubText>
          )}
        </InputLabel>
        {children}
      </Flex>
      {bottomSlot}
    </div>
  );
});
ButtonFieldLayout.displayName = 'ButtonFieldLayout';

export default ButtonFieldLayout;
